// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"pageWrapper_pageWrapper__2GseD"};